import { Button, Heading, Modal, ModalContent, ModalFooter, ModalHeader, Text, BulletList, Span } from "@netapp/bxp-design-system-react";
import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { apiClient } from "utils/clients";
import externals from "utils/externals";
import { isOrgAdminRole } from "utils/permissions";
import { ReactComponent as SuccessIcon } from './FireWorks.svg';
import { claimOrgAdmin as i18nNamespace } from "../../../../i18n/namespace";
import { Trans, useTranslation } from "react-i18next";
import _ from "lodash";
import { trackEvent } from "utils/mrTracker";

const ClaimOrgAdminSuccess = () => {
    const {selectedOrg: {name}} = useSelector((state) => state.tenancy);
    const { t } = useTranslation(i18nNamespace);
    return <>
        <Span style={{display: 'flex', justifyContent: 'center', marginBottom: '24px'}}><SuccessIcon /></Span>
        <Heading center level="16" bold style={{marginBottom: '24px'}}>{t('congratulations')}</Heading>
        <Text>{t('you_are_now', {name})}</Text>
        <Text><Trans>{t('to_manage_members')}</Trans></Text>
    </>
}

const ClaimOrgAdminDialog = ({ closeTrigger }) => {
    const [isClaimInProgress, setIsClaimInProgress] = useState(false);
    const [error, setError] = useState(null);
    const [isClaimSuccessful, setIsClaimSuccessful] = useState(false);
    const {selectedOrg, roles, user, selectedScopeId} = useSelector((state) => state.tenancy);
    const [orgAdminRoleId, setOrgAdminRoleId] = useState(null);
    const { t } = useTranslation(i18nNamespace);
    const dispatch = useDispatch();

    useEffect(() => {
        if (roles) setOrgAdminRoleId(roles.find(r => isOrgAdminRole(r))?.id);
    }, [roles])

    useEffect(() => {
        const claimOrgAdmin = async () => {
            try {
                setError(null);
                await apiClient.post(`${externals.tenancyV4Backend}/organizations/${selectedOrg.id}/roles/${orgAdminRoleId}/users`, {
                    'users':[{
                                userId: user?.id
                             }],
                    'type': 'application/vnd.netapp.bxp.userbulk',
                    'version': '1.0'
                });
                //refresh the scopes
                dispatch({
                    type: "TENANCYV4:FETCH-SCOPES",
                    payload: {
                        preScopeId: selectedScopeId,
                        forceReload: true
                    },
                });
                trackEvent({ category: 'IAM-ACTION', action: 'CLAIM-ORG-ADMIN', label: 'Status', value: 'Passed' });
                setIsClaimSuccessful(true);
            } catch (e) {
                trackEvent({ category: 'IAM-ACTION', action: 'CLAIM-ORG-ADMIN', label: 'Status', value: 'Failed' });
                console.error(e);
                setError(_.get(e, 'response.data'));
            } finally {
                setIsClaimInProgress(false);
            }
        }
        if (isClaimInProgress) {
            claimOrgAdmin();
        };
    }, [isClaimInProgress])

    return <>
        <Modal>
            <ModalHeader>
                {t('claim_the_organization')}
            </ModalHeader>
            <ModalContent>
                {!isClaimSuccessful && <>
                    <Text>{t('your_organization_hasnt_assigned')}</Text>
                    <Text style={{marginBottom: '8px'}}>{t('this_role_is_required')}</Text>
                    <BulletList liStyle={{marginBottom: '8px'}}>
                        <>{t('add_members_to_the_org')}</>
                        <>{t('assign_members_to_roles')}</>
                    </BulletList>
                    <Text style={{ marginBottom: '24px'}}><Trans>{t('these_actions_are_done')}</Trans></Text>
                    <Text>{t('if_you_claim')}</Text>
                    <BulletList liStyle={{marginBottom: '8px'}}>
                        <>{t('your_name_and_email')}</>
                        <>{t('all_other_members')}</>
                    </BulletList>
                    <Text><Trans>{t('you_can_claim_this_role')}</Trans></Text>
                </>}
                {isClaimSuccessful && <ClaimOrgAdminSuccess/>}
            </ModalContent>
            <ModalFooter error={error}>
                {!isClaimSuccessful && <Button submit isDisabled={!selectedOrg?.id || !orgAdminRoleId} onClick={() => setIsClaimInProgress(true)} isSubmitting={isClaimInProgress}>{t('claim')}</Button>}
                <Button color={isClaimSuccessful ? 'primary' : 'secondary'} isDisabled={isClaimInProgress} onClick={() => closeTrigger(isClaimSuccessful ? true : false)}>{isClaimSuccessful ? t('close') : t('cancel')}</Button>
            </ModalFooter>
        </Modal>
    </>
}

export default ClaimOrgAdminDialog